import React, { useEffect, useState } from 'react';
import { BASE_URL, Python_BASE_URL } from '../utils/config';
import Loading from './loading';
import ReactSelect from 'react-select'
import { Dialog} from '@mui/material';


const FutureSection = ({ stockSymbols, requestToken, commenteryData, isEditable, onFutureSectionChange, onFutureExpirySelect, onFutureStockSelect, onRemoveFile, onStockLossRecord, generateImage }) => {


  const [cmperror, setCmpError] = useState(false)
  const [futurecmperror, setFutureCmpError] = useState(false)
  const [slerror, setSlError] = useState(false)
  const [volumeError, setVolumeError] = useState(false)
  const [showAlert, setshowAlert] = useState(false);
  const [AlertMessage, setAlertMessage] = useState("");
  const options = stockSymbols.map((data) => ({
    ...data,
    value: data.name,
    label: data.name,
  }));
  const customStyles = {
    // Define your custom styles here
    menu: (provided) => ({
      ...provided,
      width: '256px',
      marginLeft: '185px',
    }),
    control: (provided, state) => ({
      ...provided,
      width: '256px', // Set the desired width for the entire component
      border: '1px solid #ccc',
      borderRadius: '4px',
      boxShadow: state.isFocused ? '0 0 0 1px #2684FF' : null,
      '&:hover': {
        border: '1px solid #2684FF',
      },
    }),
    // Add more styles for other elements as needed
  };


  const [futureSectionState, setFutureSectionState] = useState({
    futureReportType: 'BUY',
    stockType: '',
    cashCMP: '',
    futureCMP: '',
    futureSL: '0',
    stockIncToken: "",
    futureRemark: 'Please Note That Stop Loss is Zero, Please Calculate Risk Before Initiating Trade.',
    commentry: '',
    chartImageInterval: '1D',
    Expiry: '',
    imageData: '',
    base64Data: '',
    volume: '',
    lot_size: '',
    margin: ''
  });
  let RemarkText = 'Please Note That Stop Loss is Zero, Please Calculate Risk Before Initiating Trade.'

  const [SelectedStockRecord, setSelectedStockRecord] = useState({});
  const [ExpirySelectedRecord, setExpirySelectedRecord] = useState({})
  const [expiryData, setExpiryData] = useState([]);
  const [expiryRecord, setExpiryRecord] = useState([]);
  const [expiryshow, setexpiryshow] = useState(false);
  const [showCmpApiError, setShowCmpApiError] = useState(false)
  const [CmpErrorMsz, setCmpErrorMsz] = useState('')
  const [FutureCmpErrorMsz, setFutureCmpErrorMsz] = useState('')
  const [showFutureCmpApiError, setShowFutureCmpApiError] = useState(false)
  const [FutureSLErrorMsz, setFutureSLErrorMsz] = useState('')
  const [showFutureSLApiError, setShowFutureSLApiError] = useState(false)
  const [FutureMarginErrorMsz, setFutureMarginErrorMsz] = useState('')
  const [showFutureMarginApiError, setShowFutureMarginApiError] = useState(false)
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (commenteryData && commenteryData.length > 0) {
      const getSelectedCommentary = (type) => {
        const label = type === 'BUY' ? 'Futures Buy 1' : 'Futures Sell 1';
        console.log("label", label)
        return commenteryData.find(data => data.CommentaryName === label) || null;
      };

      const selectedData = getSelectedCommentary(futureSectionState.futureReportType);
      console.log("selectedData", selectedData)
      setFutureSectionState((prevState) => {
        const newState = {
          ...prevState,
          commentry: selectedData?.Description || '',

        }
        console.log("futureSectionState form futuresection.js", newState);

        onFutureSectionChange(newState);

        return newState;
      })
    }
  }, [commenteryData]);

  //  handle input change for cashCMP and futureCMP and futureSL
  const handleInputChange = (event) => {
    setCmpError(false);
    setFutureCmpError(false);
    setSlError(false);
    const { name, value } = event.target;
    if (/^\d*\.?\d{0,2}$/.test(value)) {
      setFutureSectionState((prevState) => {
        let newState
        if (name === 'futureSL' && value == '0') {

          newState = {
            ...prevState,
            [name]: value,
            futureRemark: RemarkText
          };
        }
        else if (name === 'futureSL' && value != '0') {
          newState = {
            ...prevState,
            [name]: value,
            futureRemark: ""
          };
        }
        else {
          newState = {
            ...prevState,
            [name]: value,
          };
        }
        // Notify the parent component about the change
        onFutureSectionChange(newState);

        return newState;
      });
    } else {
      if (name === 'cashCMP') {

        setCmpError(true)
        setTimeout(() => {
          setCmpError(false)
        }, 2000);
      }
      else if (name === 'futureCMP') {
        setFutureCmpError(true)
        setTimeout(() => {
          setFutureCmpError(false)
        }, 2000);
      }
      else if (name === 'futureSL') {
        setSlError(true)
        setTimeout(() => {
          setSlError(false)
        }, 2000);
      }
      else if (name === 'volume') {
        setVolumeError(true)
        setTimeout(() => {
          setVolumeError(false)
        }, 2000);
      }
    }


  };

  // handle input change for futureReportType and commentry
  const handleChange = (event) => {

    const { name, value } = event.target;
    console.log("name value form futuresection.js", name, value);

    if (name === 'futureReportType') {

      const getSelectedCommentary = (type) => {
        const label = type === 'BUY' ? 'Futures Buy 1' : 'Futures Sell 1';
        console.log("label", label)
        return commenteryData.find(data => data.CommentaryName === label) || null;
      };

      const selectedData = getSelectedCommentary(value);
      console.log("selectedData", selectedData)
      setFutureSectionState((prevState) => {
        const newState = {
          ...prevState,
          futureReportType: value,
          commentry: selectedData?.Description || '',
          stockType: '',
          cashCMP: '',
          futureCMP: '',
          futureSL: '0',
          stockIncToken: "",
          futureRemark: 'Please Note That Stop Loss is Zero, Please Calculate Risk Before Initiating Trade.',
          chartImageInterval: '1D',
          Expiry: '',
          imageData: '',
          base64Data: '',
          volume: '',
          lot_size: '',
          margin: ''
        }
        console.log("futureSectionState form futuresection.js", newState);

        onFutureSectionChange(newState);

        return newState;
      })
    } else {

      setFutureSectionState((prevState) => {
        const newState = {
          ...prevState,
          [name]: value,
        };

        // Log the updated state
        console.log("futureSectionState form futuresection.js", newState);

        // Notify the parent component about the change
        onFutureSectionChange(newState);

        return newState;
      });

    }


  };

  // handle input change for chart interval for image
  const handleChartinterval = (event) => {

    const { name, value } = event.target;
 if (!futureSectionState.stockType || !futureSectionState.Expiry) {
    console.log("Stock symbol not available. Skipping interval change.");
    setAlertMessage(`Please Select Stock Name and Expiry First then try to change the Image Interaval.`);
      setshowAlert(true);
      setTimeout(() => {
        setshowAlert(false);
        setAlertMessage('')
      }, 3000);
    return;
  }
    setFutureSectionState((prevState) => {
      const newState = {
        ...prevState,
        [name]: value,
      };

      onFutureSectionChange(newState);

      generateImage(SelectedStockRecord.TV_STOCK_Symbol, SelectedStockRecord.TVExchange, value)


      return newState;
    });
  };

  // handle input change for stock name
  const handlechangestock = async (event) => {
    // const { name, value } = event.target;
    setLoading(true)
    // const { name, value } = event;
    let matchingRecord
    let Expiry_date
    let selectedStockRecord
    console.log("event", event)
    const type = 'NFO-FUT';



    setFutureSectionState((prevState) => {
      const newState = {
        ...prevState,
        stockType: event.name,
        cashCMP: '',
        futureCMP: '',
        futureSL: '0',
        futureRemark: 'Please Note That Stop Loss is Zero, Please Calculate Risk Before Initiating Trade.',
        Expiry: '',
        imageData: '',
        volume: '',
        margin: ''
      };

      onRemoveFile();


      // Log the updated state
      // console.log("futureSectionState", newState);

      // Notify the parent component about the change

      selectedStockRecord = stockSymbols.find(item => item.name === event.value);
      setSelectedStockRecord(selectedStockRecord);
      generateImage(selectedStockRecord.TV_STOCK_Symbol, selectedStockRecord.TVExchange, futureSectionState.chartImageInterval)
      onFutureStockSelect(selectedStockRecord);
      onFutureSectionChange(newState);
      return newState;
    });


    //  call expiry

    if (!event.value) {
      console.error('Error: Stock name is required.');
      setFutureSectionState((prevState) => {
        const newState = {
          ...prevState,
          Expiry: '',
          lot_size: '',
        };
        onFutureSectionChange(newState);
        return newState;
      });
      return;
    }

    await fetch(`${BASE_URL}/getstockexpiry/${event.value}/${type}`, {
      method: 'GET'
    })
      .then(response => response.json())
      .then(res => {
        // Process the API response data
        if (res.success === true) {
          let expiryData = JSON.parse(res.data[0].dates);
          let expiryRecord = JSON.parse(res.data[0].Kite_Data);

          console.log("expiryData", expiryData);
          console.log("expiryRecord", expiryRecord);
          Expiry_date = expiryData[0].expiry;

          const selectedExpiryRecord = expiryRecord.find(item => item.expiry === expiryData[0].expiry);
          console.log("selectedExpiryRecord", selectedExpiryRecord);
          setExpirySelectedRecord(selectedExpiryRecord);

          setExpiryData(expiryData);
          setExpiryRecord(expiryRecord);
          setexpiryshow(true);
          setFutureSectionState((prevState) => {
            const newState = {
              ...prevState,
              Expiry: expiryData[0].expiry,
              lot_size: selectedExpiryRecord.lot_size
            };
            matchingRecord = selectedExpiryRecord;
            onFutureExpirySelect(selectedExpiryRecord);
            onFutureSectionChange(newState);
            return newState;
          });
        } else {
          setAlertMessage(`Error: ${res.message || 'Failed to fetch expiry data.'}`);
          setshowAlert(true);
          setTimeout(() => {
            setshowAlert(false);
            setAlertMessage('');
          }, 2000);

        }
      })
      .catch(error => {
        // Handle errors
        console.error('Error fetching data:', error);
        setAlertMessage(`Error: ${error.message || 'An unexpected error occurred while fetching expiry data.'}`);
        setshowAlert(true);
        setTimeout(() => {
          setshowAlert(false);
          setAlertMessage('');
        }, 2000);
      });


    //  call cmp 
    if (!event.value || !requestToken || !Expiry_date) {
      console.error('Error: Missing required parameters for API call.');
      setCmpErrorMsz('Missing required parameters for API call.');
      setShowCmpApiError(true);
      setTimeout(() => {
        setShowCmpApiError(false);
        setCmpErrorMsz('');
      }, 1000);
      return;
    }

    await fetch(`${BASE_URL}/getcmpprice/${event.value}/${requestToken}/${Expiry_date}`, {
      method: 'GET',
      headers: {
        "Content-Type": "application/json",
      },
    })
      .then(response => response.json())
      .then(res => {
        // Process the API response data
        if (res.success === true) {
          console.log("res.data", res.instruments);
          let Stock_IncToken = res.stock_IncToken;
          let last_price = res.instruments.last_price;

          setFutureSectionState((prevState) => {
            const newState = {
              ...prevState,
              cashCMP: last_price,
              stockIncToken: Stock_IncToken,
            };

            // Notify the parent component about the change
            onFutureSectionChange(newState);

            return newState;
          });
        } else {
          setCmpErrorMsz(res.message);
          setShowCmpApiError(true);
          setFutureSectionState((prevState) => {
            const newState = {
              ...prevState,
              cashCMP: "",
              stockIncToken: "",
            };

            // Notify the parent component about the change
            onFutureSectionChange(newState);

            return newState;
          });
          setTimeout(() => {
            setShowCmpApiError(false);
            setCmpErrorMsz('');
          }, 1500);
        }
      }).catch(error => {
        // Handle errors
        setCmpErrorMsz(error.message);
        setShowCmpApiError(true);
        setFutureSectionState((prevState) => {
          const newState = {
            ...prevState,
            cashCMP: "",
          };

          // Notify the parent component about the change
          onFutureSectionChange(newState);

          return newState;
        });
        setTimeout(() => {
          setShowCmpApiError(false);
          setCmpErrorMsz('');
        }, 1500);
        console.error('Error fetching data:', error);
      });

    let reportType
    if (futureSectionState.futureReportType === 'Sell') {
      reportType = 'SALE'
    } else {
      reportType = 'BUY'
    }
    if (!reportType || !event.value || !Expiry_date || !selectedStockRecord.TV_STOCK_Symbol) {
      console.error('Error: Missing required parameters for futureStopLoss API call.', {
        reportType,
        symbol: event.value,
        expiry: Expiry_date,
        tvsymbol: selectedStockRecord.TV_STOCK_Symbol
      });
      setFutureSLErrorMsz(`Missing required parameters for futureStopLoss API call. ReportType = ${reportType}, StockName = ${event.value}, Expiry = ${Expiry_date}, TV_StockSymbol = ${selectedStockRecord.TV_STOCK_Symbol}`);
      setShowFutureSLApiError(true);
      setTimeout(() => {

        setShowFutureSLApiError(false);
        setFutureSLErrorMsz('');
      }, 1500);
      return;
    }

    let body = JSON.stringify({
      report_type: reportType,
      symbol: event.value,
      expiry: Expiry_date,
      tvsymbol: selectedStockRecord.TV_STOCK_Symbol
    });

    await fetch(`${Python_BASE_URL}/futureStopLoss`, {
      method: 'POST',
      body,
      headers: {
        "Content-Type": "application/json",
      },
    })
      .then(response => response.json())
      .then(res => {
        if (res.success === true) {
          console.log("res.data", res);
          let stockrecord;
          if (futureSectionState.futureReportType === 'Sell') {
            stockrecord = res.Record.find(item => item.high == res.StopLoss);
          } else {
            stockrecord = res.Record.find(item => item.low == res.StopLoss);
          }

          if (!stockrecord) {
            if (futureSectionState.futureReportType === 'Sell') {
              const nearestLowRecord = res.Record.reduce((prev, curr) => {
                const prevDiff = Math.abs(prev.high - res.StopLoss);
                const currDiff = Math.abs(curr.high - res.StopLoss);
                return prevDiff < currDiff ? prev : curr;
              });
              stockrecord = nearestLowRecord;
            } else {
              const nearestHighRecord = res.Record.reduce((prev, curr) => {
                const prevDiff = Math.abs(prev.low - res.StopLoss);
                const currDiff = Math.abs(curr.low - res.StopLoss);
                return prevDiff < currDiff ? prev : curr;
              });
              stockrecord = nearestHighRecord;
            }
          }

          const roundedStopLoss = parseFloat(res.StopLoss.toFixed(2));
          onStockLossRecord(stockrecord);
          setFutureSectionState((prevState) => {
            const newState = {
              ...prevState,
              futureSL: roundedStopLoss,
              volume: stockrecord.volume,
              futureRemark: ''
            };
            onFutureSectionChange(newState);
            return newState;
          });
          setLoading(false);
        } else {
          console.error('Error: Failed to fetch futureStopLoss data.', res.message);
          setFutureSLErrorMsz(`Error: ${res.message}`);
          setShowFutureSLApiError(true);
          setFutureSectionState((prevState) => {
            const newState = {
              ...prevState,
              futureSL: '0',
              volume: '',
              futureRemark: 'Please Note That Stop Loss is Zero, Please Calculate Risk Before Initiating Trade.'
            };
            onFutureSectionChange(newState);
            return newState;
          });
          setLoading(false);
          setTimeout(() => {
            setShowFutureSLApiError(false);
            setFutureSLErrorMsz('');
          }, 1500);
        }
      })
      .catch(error => {
        console.error('Error fetching futureStopLoss data:', error);
        setFutureSLErrorMsz(`Error: ${error.message}`);
        setShowFutureSLApiError(true);
        setFutureSectionState((prevState) => {
          const newState = {
            ...prevState,
            futureSL: '',
            volume: '',
            futureRemark: 'Please Note That Stop Loss is Zero, Please Calculate Risk Before Initiating Trade.'
          };
          onFutureSectionChange(newState);
          return newState;
        });
        setLoading(false);
        setTimeout(() => {
          setShowFutureSLApiError(false);
          setFutureSLErrorMsz('');
        }, 1500);
      });
    //  let body = JSON.stringify({request_token:requestToken})
    if (!matchingRecord || !matchingRecord.instrument_token) {
      console.error('Error: Missing instrument token for API call.');
      setFutureCmpErrorMsz('Missing instrument token for API call.');
      setShowFutureCmpApiError(true);
      setFutureSectionState((prevState) => {
        const newState = {
          ...prevState,
          futureCMP: "",
        };

        // Notify the parent component about the change
        onFutureSectionChange(newState);

        return newState;
      });
      setTimeout(() => {
        setShowFutureCmpApiError(false);
        setFutureCmpErrorMsz('');
      }, 1500);
      return;
    }

    await fetch(`${BASE_URL}/getkitedata/${matchingRecord.instrument_token}/${requestToken}`, {
      method: 'GET',
      headers: {
        "Content-Type": "application/json",
      },
    })
      .then(response => response.json())
      .then(res => {
        // Process the API response data
        if (res.success === true) {
          let last_price = res.instruments.last_price;
          setFutureSectionState((prevState) => {
            const newState = {
              ...prevState,
              futureCMP: last_price,
            };

            // Notify the parent component about the change
            onFutureSectionChange(newState);

            return newState;
          });
        } else {
          setFutureCmpErrorMsz(`Error: ${res.message}`);
          setShowFutureCmpApiError(true);
          setFutureSectionState((prevState) => {
            const newState = {
              ...prevState,
              futureCMP: "",
            };

            // Notify the parent component about the change
            onFutureSectionChange(newState);

            return newState;
          });
          setTimeout(() => {
            setShowFutureCmpApiError(false);
            setFutureCmpErrorMsz('');
          }, 1500);
        }
      })
      .catch(error => {
        // Handle errors
        setFutureCmpErrorMsz(`Error: ${error.message}`);
        setShowFutureCmpApiError(true);
        setFutureSectionState((prevState) => {
          const newState = {
            ...prevState,
            futureCMP: "",
          };

          // Notify the parent component about the change
          onFutureSectionChange(newState);

          return newState;
        });
        setTimeout(() => {
          setShowFutureCmpApiError(false);
          setFutureCmpErrorMsz('');
        }, 1500);
        console.error('Error fetching data:', error);
      });



    //calculate margin 
    if (!matchingRecord || !matchingRecord.tradingsymbol || !futureSectionState.futureReportType || !event.lot_size) {
      console.error('Error: Missing required parameters for calculateMargin API call.', {
        tradingsymbol: matchingRecord?.tradingsymbol,
        transaction_type: futureSectionState.futureReportType,
        quantity: event?.lot_size,
      });

      setFutureMarginErrorMsz('Missing required parameters for calculateMargin API call.');
      setShowFutureMarginApiError(true);
      setTimeout(() => {
        setShowFutureMarginApiError(false);
        setFutureMarginErrorMsz('');

      }, 1500);
      return;
    }

    let Marginbody = JSON.stringify({
      exchange: "NFO",
      tradingsymbol: matchingRecord.tradingsymbol,
      transaction_type: futureSectionState.futureReportType,
      quantity: event.lot_size,
    });

    await fetch(`${BASE_URL}/calculateMarginForMCX`, {
      method: 'POST',
      body: Marginbody,
      headers: {
        "Content-Type": "application/json",
      },
    })
      .then(response => response.json())
      .then(res => {
        // Process the API response data
        console.log("margin ===================res ", res);

        if (res.success === true) {
          setFutureSectionState((prevState) => {
            const newState = {
              ...prevState,
              margin: res.orderMargins,
            };
            onFutureSectionChange(newState);

            return newState;
          });
        } else {
          setFutureSectionState((prevState) => {
            const newState = {
              ...prevState,
              margin: "",
            };
            onFutureSectionChange(newState);
            return newState;
          });
          setFutureMarginErrorMsz(`Error: ${res.message}`);
          setShowFutureMarginApiError(true);
          setTimeout(() => {
            setShowFutureMarginApiError(false);
            setFutureMarginErrorMsz('');

          }, 1500);
        }
      })
      .catch(error => {
        // Handle errors
        setFutureSectionState((prevState) => {
          const newState = {
            ...prevState,
            margin: "",
          };

          // Notify the parent component about the change
          onFutureSectionChange(newState);

          return newState;
        });
        setFutureMarginErrorMsz(`Error: ${error.message}`);
        setShowFutureMarginApiError(true);
        setTimeout(() => {
          setShowFutureMarginApiError(false);
          setFutureMarginErrorMsz('');

        }, 1500);
        console.error('Error fetching data:', error);
      });
  }


  // to format Expiry date to show in the dropdown
  const formatDate = (dateString) => {

    const dateObject = new Date(dateString);
    const day = dateObject.getDate();
    const month = dateObject.getMonth() + 1; // Months are zero-based
    const year = dateObject.getFullYear();

    // Pad single-digit day and month with a leading zero
    const formattedDate = `${day < 10 ? '0' : ''}${day}-${month < 10 ? '0' : ''}${month}-${year}`;

    return formattedDate;
  }


  // to handle expiry date change
  const handlechangeExpiry = async (event) => {
    setLoading(true);
    const { name, value } = event.target;
    const selectedExpiryRecord = expiryRecord.find(item => item.expiry === value);
    console.log("selectedExpiryRecord", selectedExpiryRecord)
    setFutureSectionState((prevState) => {
      const newState = {
        ...prevState,
        [name]: value,
        lot_size: selectedExpiryRecord.lot_size,
        cashCMP: '',
        futureCMP: '',
        futureSL: '0',
        futureRemark: 'Please Note That Stop Loss is Zero, Please Calculate Risk Before Initiating Trade.',

        imageData: '',
        volume: '',
        margin: ''
      };

      // Log the updated state
      // console.log("futureSectionState", newState);

      // Notify the parent component about the change

      onFutureExpirySelect(selectedExpiryRecord);
      onFutureSectionChange(newState);

      return newState;
    });

    await fetchFutureCMP(value);
  }


  // to handle commentary change
  const handleOptionChange = (event) => {
    const { name, value } = event.target;
    const selected = commenteryData.find(item => item.CommentaryName === value);

    setFutureSectionState((prevState) => {
      const newState = {
        ...prevState,
        [name]: selected?.Description || '',
      };

      // Log the updated state
      // console.log("futureSectionState", newState);

      // Notify the parent component about the change
      onFutureSectionChange(newState);



      return newState;
    });


  };

  // to handle api to fetch CMP and stop loss
  const fetchCMP = async (event) => {
    // console.log(event)
    event.preventDefault();
    setLoading(true);

    setFutureSectionState((prevState) => {
      const newState = {
        ...prevState,
        cashCMP: '',
        futureCMP: '',
        futureSL: '0',
        futureRemark: 'Please Note That Stop Loss is Zero, Please Calculate Risk Before Initiating Trade.',

        imageData: '',
        volume: '',
        margin: ''
      };

      onFutureSectionChange(newState);

      return newState;
    });

    const StockName = futureSectionState.stockType
    console.log("StockName", StockName);


    if (!StockName || !requestToken || !futureSectionState.Expiry) {
      console.error('Error: Missing required parameters for API call.', {
        StockName,
        requestToken,
        Expiry: futureSectionState.Expiry,
      });
      setCmpErrorMsz('Missing required parameters for API call.');
      setShowCmpApiError(true);
      setTimeout(() => {
        setShowCmpApiError(false);
        setCmpErrorMsz('');
      }, 2000);
      return;
    }

    await fetch(`${BASE_URL}/getcmpprice/${StockName}/${requestToken}/${futureSectionState.Expiry}`, {
      method: 'GET',
      headers: {
        "Content-Type": "application/json",
      },
    })
      .then(response => response.json())
      .then(res => {
        if (res.success === true) {
          console.log("res.data", res.instruments);
          let last_price = res.instruments.last_price;

          setFutureSectionState((prevState) => {
            const newState = {
              ...prevState,
              cashCMP: last_price,
            };

            onFutureSectionChange(newState);
            return newState;
          });
        } else {
          console.error('Error: Failed to fetch CMP data.', res.message);
          setCmpErrorMsz(res.message || 'Failed to fetch CMP data.');
          setShowCmpApiError(true);
          setFutureSectionState((prevState) => {
            const newState = {
              ...prevState,
              cashCMP: "",
            };

            onFutureSectionChange(newState);
            return newState;
          });
          setTimeout(() => {
            setShowCmpApiError(false);
            setCmpErrorMsz('');
          }, 2000);
        }
      })
      .catch(error => {
        console.error('Error fetching CMP data:', error);
        setCmpErrorMsz(error.message || 'An unexpected error occurred.');
        setShowCmpApiError(true);
        setFutureSectionState((prevState) => {
          const newState = {
            ...prevState,
            cashCMP: "",
          };

          onFutureSectionChange(newState);
          return newState;
        });
        setTimeout(() => {
          setShowCmpApiError(false);
          setCmpErrorMsz('');
        }, 2000);
      });



    // Check if all required values are present
    if (!futureSectionState.futureReportType || !futureSectionState.stockType || !futureSectionState.Expiry || !SelectedStockRecord.TV_STOCK_Symbol) {
      console.error('Error: Missing required parameters for futureStopLoss API call.', {
        futureReportType: futureSectionState.futureReportType,
        stockType: futureSectionState.stockType,
        Expiry: futureSectionState.Expiry,
        tvsymbol: SelectedStockRecord.TV_STOCK_Symbol
      });
      setFutureSLErrorMsz('Missing required parameters for futureStopLoss API call.');
      setShowFutureSLApiError(true);
      setTimeout(() => {
        setShowFutureSLApiError(false);
        setFutureSLErrorMsz('');
      }, 2000);
      return;
    }

    let reportType;
    if (futureSectionState.futureReportType === 'Sell') {
      reportType = 'SALE';
    } else {
      reportType = 'BUY';
    }

    let body = JSON.stringify({
      report_type: reportType,
      symbol: futureSectionState.stockType,
      expiry: futureSectionState.Expiry,
      tvsymbol: SelectedStockRecord.TV_STOCK_Symbol
    });

    await fetch(`${Python_BASE_URL}/futureStopLoss`, {
      method: 'POST',
      body,
      headers: {
        "Content-Type": "application/json",
      },
    })
      .then(response => response.json())
      .then(res => {
        if (res.success === true) {
          console.log("res.data", res);
          let stockrecord;
          if (futureSectionState.futureReportType === 'Sell') {
            stockrecord = res.Record.find(item => item.high == res.StopLoss);
          } else {
            stockrecord = res.Record.find(item => item.low == res.StopLoss);
          }

          if (!stockrecord) {
            if (futureSectionState.futureReportType === 'Sell') {
              const nearestLowRecord = res.Record.reduce((prev, curr) => {
                const prevDiff = Math.abs(prev.high - res.StopLoss);
                const currDiff = Math.abs(curr.high - res.StopLoss);
                return prevDiff < currDiff ? prev : curr;
              });
              stockrecord = nearestLowRecord;
            } else {
              const nearestHighRecord = res.Record.reduce((prev, curr) => {
                const prevDiff = Math.abs(prev.low - res.StopLoss);
                const currDiff = Math.abs(curr.low - res.StopLoss);
                return prevDiff < currDiff ? prev : curr;
              });
              stockrecord = nearestHighRecord;
            }
          }

          const roundedStopLoss = parseFloat(res.StopLoss.toFixed(2));
          onStockLossRecord(stockrecord);
          setFutureSectionState((prevState) => {
            const newState = {
              ...prevState,
              futureSL: roundedStopLoss,
              volume: stockrecord.volume,
              futureRemark: ''
            };
            onFutureSectionChange(newState);
            return newState;
          });
          setLoading(false);
        } else {
          setFutureSLErrorMsz(`Error: ${res.message}`);
          setShowFutureSLApiError(true);
          setFutureSectionState((prevState) => {
            const newState = {
              ...prevState,
              futureSL: '0',
              volume: '',
              futureRemark: 'Please Note That Stop Loss is Zero, Please Calculate Risk Before Initiating Trade.'
            };
            onFutureSectionChange(newState);
            return newState;
          });
          setLoading(false);
          setTimeout(() => {
            setShowFutureSLApiError(false);
            setFutureSLErrorMsz('');
          }, 2000);
        }
      })
      .catch(error => {
        setFutureSLErrorMsz(`Error: ${error.message}`);
        setShowFutureSLApiError(true);
        setFutureSectionState((prevState) => {
          const newState = {
            ...prevState,
            futureSL: '',
            volume: '',
            futureRemark: 'Please Note That Stop Loss is Zero, Please Calculate Risk Before Initiating Trade.'
          };
          onFutureSectionChange(newState);
          return newState;
        });
        setLoading(false);
        setTimeout(() => {
          setShowFutureSLApiError(false);
          setFutureSLErrorMsz('');
        }, 2000);
        console.error('Error fetching data:', error);
      });
    //  let body = JSON.stringify({request_token:requestToken})


    if (!ExpirySelectedRecord || !ExpirySelectedRecord.instrument_token) {
      console.error('Error: Missing required parameters for getkitedata API call.', {
        instrument_token: ExpirySelectedRecord?.instrument_token,

      });
      setFutureCmpErrorMsz('Missing required parameters for getkitedata API call.');
      setShowFutureCmpApiError(true);
      setFutureSectionState((prevState) => {
        const newState = {
          ...prevState,
          futureCMP: "",
        };
        onFutureSectionChange(newState);
        return newState;
      });
      setTimeout(() => {
        setShowFutureCmpApiError(false);
        setFutureCmpErrorMsz('');
      }, 1000);
      return;
    }

    await fetch(`${BASE_URL}/getkitedata/${ExpirySelectedRecord.instrument_token}/${requestToken}`, {
      method: 'GET',
      headers: {
        "Content-Type": "application/json",
      },
    })
      .then(response => response.json())
      .then(res => {
        if (res.success === true) {
          let last_price = res.instruments.last_price;
          setFutureSectionState((prevState) => {
            const newState = {
              ...prevState,
              futureCMP: last_price,
            };
            onFutureSectionChange(newState);
            return newState;
          });
        } else {
          console.error('Error: Failed to fetch futureCMP data.', res.message);
          setFutureCmpErrorMsz(res.message || 'Failed to fetch futureCMP data.');
          setShowFutureCmpApiError(true);
          setFutureSectionState((prevState) => {
            const newState = {
              ...prevState,
              futureCMP: "",
            };
            onFutureSectionChange(newState);
            return newState;
          });
          setTimeout(() => {
            setShowFutureCmpApiError(false);
            setFutureCmpErrorMsz('');
          }, 1000);
        }
      })
      .catch(error => {
        console.error('Error fetching futureCMP data:', error);
        setFutureCmpErrorMsz(error.message || 'An unexpected error occurred.');
        setShowFutureCmpApiError(true);
        setFutureSectionState((prevState) => {
          const newState = {
            ...prevState,
            futureCMP: "",
          };
          onFutureSectionChange(newState);
          return newState;
        });
        setTimeout(() => {
          setShowFutureCmpApiError(false);
          setFutureCmpErrorMsz('');
        }, 1000);
      });



    //calculate margin 
    if (!ExpirySelectedRecord || !ExpirySelectedRecord.tradingsymbol || !futureSectionState.futureReportType || !ExpirySelectedRecord.lot_size) {
      console.error('Error: Missing required parameters for calculateMargin API call.', {
        tradingsymbol: ExpirySelectedRecord?.tradingsymbol,
        transaction_type: futureSectionState.futureReportType,
        quantity: ExpirySelectedRecord?.lot_size,
      });

      setFutureMarginErrorMsz('Missing required parameters for calculateMargin API call.');
      setShowFutureMarginApiError(true);
      setTimeout(() => {
        setShowFutureMarginApiError(false);
        setFutureMarginErrorMsz('');
      }, 2000);
      return;
    }

    let Marginbody = JSON.stringify({
      exchange: "NFO",
      tradingsymbol: ExpirySelectedRecord.tradingsymbol,
      transaction_type: futureSectionState.futureReportType,
      quantity: ExpirySelectedRecord.lot_size,
    });

    await fetch(`${BASE_URL}/calculateMarginForMCX`, {
      method: 'POST',
      body: Marginbody,
      headers: {
        "Content-Type": "application/json",
      },
    })
      .then(response => response.json())
      .then(res => {
        setLoading(false);
        if (res.success === true) {
          setFutureSectionState((prevState) => {
            const newState = {
              ...prevState,
              margin: res.orderMargins,
            };
            onFutureSectionChange(newState);
            return newState;
          });
        } else {
          console.error('Error: Failed to calculate margin.', res.message);
          setFutureMarginErrorMsz(res.message || 'Failed to calculate margin.');
          setShowFutureMarginApiError(true);
          setFutureSectionState((prevState) => {
            const newState = {
              ...prevState,
              margin: "",
            };
            onFutureSectionChange(newState);
            return newState;
          });
          setTimeout(() => {
            setShowFutureMarginApiError(false);
            setFutureMarginErrorMsz('');
          }, 2000);
        }
      })
      .catch(error => {
        console.error('Error fetching margin data:', error);
        setLoading(false);
        setFutureMarginErrorMsz(error.message || 'An unexpected error occurred.');
        setShowFutureMarginApiError(true);
        setFutureSectionState((prevState) => {
          const newState = {
            ...prevState,
            margin: "",
          };
          onFutureSectionChange(newState);
          return newState;
        });
        setTimeout(() => {
          setShowFutureMarginApiError(false);
          setFutureMarginErrorMsz('');
        }, 2000);
      });
  }

  // to fetch future cmp and stop loss
  const fetchFutureCMP = async (expiry) => {
    // event.preventDefault();
    const matchingRecord = expiryRecord.find(item => item.expiry === expiry);
    console.log("matchingRecord", matchingRecord);


    const StockName = futureSectionState.stockType
    console.log("StockName", StockName);
    
    if (!StockName  || !futureSectionState.Expiry) {
      console.error('Error: Missing required parameters for API call.', {
      StockName,
      Expiry: futureSectionState.Expiry,
      });
      setCmpErrorMsz('Missing required parameters for API call.');
      setShowCmpApiError(true);
      setTimeout(() => {
      setShowCmpApiError(false);
      setCmpErrorMsz('');
      }, 2000);
      return;
    }

    await fetch(`${BASE_URL}/getcmpprice/${StockName}/${requestToken}/${futureSectionState.Expiry}`, {
      method: 'GET',
      headers: {
      "Content-Type": "application/json",
      },
    })
      .then(response => response.json())
      .then(res => {
      if (res.success === true) {
        console.log("res.data", res.instruments);
        let last_price = res.instruments.last_price;

        setFutureSectionState((prevState) => {
        const newState = {
          ...prevState,
          cashCMP: last_price,
        };

        onFutureSectionChange(newState);
        return newState;
        });
      } else {
        console.error('Error: Failed to fetch CMP data.', res.message);
        setCmpErrorMsz(res.message || 'Failed to fetch CMP data.');
        setShowCmpApiError(true);
        setFutureSectionState((prevState) => {
        const newState = {
          ...prevState,
          cashCMP: "",
        };

        onFutureSectionChange(newState);
        return newState;
        });
        setTimeout(() => {
        setShowCmpApiError(false);
        setCmpErrorMsz('');
        }, 2000);
      }
      })
      .catch(error => {
      console.error('Error fetching CMP data:', error);
      setCmpErrorMsz(error.message || 'An unexpected error occurred.');
      setShowCmpApiError(true);
      setFutureSectionState((prevState) => {
        const newState = {
        ...prevState,
        cashCMP: "",
        };

        onFutureSectionChange(newState);
        return newState;
      });
      setTimeout(() => {
        setShowCmpApiError(false);
        setCmpErrorMsz('');
      }, 2000);
      });

    //  let body = JSON.stringify({request_token:requestToken})
    if (!matchingRecord || !matchingRecord.instrument_token ) {
      console.error('Error: Missing required parameters for getkitedata API call.', {
      instrument_token: matchingRecord?.instrument_token,
     
      });
      setFutureCmpErrorMsz('Missing required parameters for getkitedata API call.');
      setShowFutureCmpApiError(true);
      setFutureSectionState((prevState) => {
      const newState = {
        ...prevState,
        futureCMP: "",
      };
      onFutureSectionChange(newState);
      return newState;
      });
      setTimeout(() => {
      setShowFutureCmpApiError(false);
      setFutureCmpErrorMsz('');
      }, 2000);
      return;
    }

    await fetch(`${BASE_URL}/getkitedata/${matchingRecord.instrument_token}/${requestToken}`, {
      method: 'GET',
      headers: {
      "Content-Type": "application/json",
      },
    })
      .then(response => response.json())
      .then(res => {
      if (res.success === true) {
        let last_price = res.instruments.last_price;

        setFutureSectionState((prevState) => {
        const newState = {
          ...prevState,
          futureCMP: last_price,
        };
        onFutureSectionChange(newState);
        return newState;
        });
      } else {
        console.error('Error: Failed to fetch futureCMP data.', res.message);
        setFutureCmpErrorMsz(res.message || 'Failed to fetch futureCMP data.');
        setShowFutureCmpApiError(true);
        setFutureSectionState((prevState) => {
        const newState = {
          ...prevState,
          futureCMP: "",
        };
        onFutureSectionChange(newState);
        return newState;
        });
        setTimeout(() => {
        setShowFutureCmpApiError(false);
        setFutureCmpErrorMsz('');
        }, 2000);
      }
      })
      .catch(error => {
      console.error('Error fetching futureCMP data:', error);
      setFutureCmpErrorMsz(error.message || 'An unexpected error occurred.');
      setShowFutureCmpApiError(true);
      setFutureSectionState((prevState) => {
        const newState = {
        ...prevState,
        futureCMP: "",
        };
        onFutureSectionChange(newState);
        return newState;
      });
      setTimeout(() => {
        setShowFutureCmpApiError(false);
        setFutureCmpErrorMsz('');
      }, 2000);
      });

    await fetchStopLoss(expiry);
    //calculate margin 
    if (!matchingRecord || !matchingRecord.tradingsymbol || !futureSectionState.futureReportType || !futureSectionState.lot_size) {
      console.error('Error: Missing required parameters for calculateMargin API call.', {
      tradingsymbol: matchingRecord?.tradingsymbol,
      transaction_type: futureSectionState.futureReportType,
      quantity: futureSectionState.lot_size,
      });

      setFutureMarginErrorMsz('Missing required parameters for calculateMargin API call.');
      setShowFutureMarginApiError(true);
      setTimeout(() => {
      setShowFutureMarginApiError(false);
      setFutureMarginErrorMsz('');
      }, 2000);
      return;
    }

    let Marginbody = JSON.stringify({
      exchange: "NFO",
      tradingsymbol: matchingRecord.tradingsymbol,
      transaction_type: futureSectionState.futureReportType,
      quantity: futureSectionState.lot_size,
    });

    await fetch(`${BASE_URL}/calculateMarginForMCX`, {
      method: 'POST',
      body: Marginbody,
      headers: {
      "Content-Type": "application/json",
      },
    })
      .then(response => response.json())
      .then(res => {
      console.log("margin ===================res ", res);

      if (res.success === true) {
        setFutureSectionState((prevState) => {
        const newState = {
          ...prevState,
          margin: res.orderMargins,
        };
        onFutureSectionChange(newState);

        return newState;
        });
      } else {
        console.error('Error: Failed to calculate margin.', res.message);
        setFutureMarginErrorMsz(res.message || 'Failed to calculate margin.');
        setShowFutureMarginApiError(true);
        setFutureSectionState((prevState) => {
        const newState = {
          ...prevState,
          margin: "",
        };
        onFutureSectionChange(newState);
        return newState;
        });
        setTimeout(() => {
        setShowFutureMarginApiError(false);
        setFutureMarginErrorMsz('');
        }, 2000);
      }
      })
      .catch(error => {
      console.error('Error fetching margin data:', error);
      setFutureMarginErrorMsz(error.message || 'An unexpected error occurred.');
      setShowFutureMarginApiError(true);
      setFutureSectionState((prevState) => {
        const newState = {
        ...prevState,
        margin: "",
        };
        onFutureSectionChange(newState);
        return newState;
      });
      setTimeout(() => {
        setShowFutureMarginApiError(false);
        setFutureMarginErrorMsz('');
      }, 2000);
      });
  }
 // to fetch stop loss
  const fetchStopLoss = async (expiry) => {
    let reportType
    if (futureSectionState.futureReportType === 'Sell') {
      reportType = 'SALE'
    } else {
      reportType = 'BUY'
    }
    if (!reportType || !futureSectionState.stockType || !futureSectionState.Expiry || !SelectedStockRecord.TV_STOCK_Symbol) {
      console.error('Error: Missing required parameters for futureStopLoss API call.', {
      reportType,
      symbol: futureSectionState.stockType,
      expiry: futureSectionState.Expiry,
      tvsymbol: SelectedStockRecord.TV_STOCK_Symbol
      });
      setFutureSLErrorMsz('Missing required parameters for futureStopLoss API call.');
      setShowFutureSLApiError(true);
      setTimeout(() => {
      setShowFutureSLApiError(false);
      setFutureSLErrorMsz('');
      }, 2000);
      return;
    }

    let body = JSON.stringify({
      report_type: reportType,
      symbol: futureSectionState.stockType,
      expiry: futureSectionState.Expiry,
      tvsymbol: SelectedStockRecord.TV_STOCK_Symbol
    });

    await fetch(`${Python_BASE_URL}/futureStopLoss`, {
      method: 'POST',
      body,
      headers: {
      "Content-Type": "application/json",
      },
    })
      .then(response => response.json())
      .then(res => {
      if (res.success === true) {
        console.log("res.data", res);
        let stockrecord;
        if (futureSectionState.futureReportType === 'Sell') {
        stockrecord = res.Record.find(item => item.high == res.StopLoss);
        } else {
        stockrecord = res.Record.find(item => item.low == res.StopLoss);
        }

        if (!stockrecord) {
        if (futureSectionState.futureReportType === 'Sell') {
          const nearestLowRecord = res.Record.reduce((prev, curr) => {
          const prevDiff = Math.abs(prev.high - res.StopLoss);
          const currDiff = Math.abs(curr.high - res.StopLoss);
          return prevDiff < currDiff ? prev : curr;
          });
          stockrecord = nearestLowRecord;
        } else {
          const nearestHighRecord = res.Record.reduce((prev, curr) => {
          const prevDiff = Math.abs(prev.low - res.StopLoss);
          const currDiff = Math.abs(curr.low - res.StopLoss);
          return prevDiff < currDiff ? prev : curr;
          });
          stockrecord = nearestHighRecord;
        }
        }
        const roundedStopLoss = parseFloat(res.StopLoss.toFixed(2));
        onStockLossRecord(stockrecord);
        setFutureSectionState((prevState) => {
        const newState = {
          ...prevState,
          futureSL: roundedStopLoss,
          volume: stockrecord.volume,
          futureRemark: ''
        };
        onFutureSectionChange(newState);
        return newState;
        });
        setLoading(false);
      } else {
        setFutureSLErrorMsz(`Error: ${res.message}`);
        setShowFutureSLApiError(true);
        setFutureSectionState((prevState) => {
        const newState = {
          ...prevState,
          futureSL: '0',
          volume: '',
          futureRemark: 'Please Note That Stop Loss is Zero, Please Calculate Risk Before Initiating Trade.'
        };
        onFutureSectionChange(newState);
        return newState;
        });
        setLoading(false);
        setTimeout(() => {
        setShowFutureSLApiError(false);
        setFutureSLErrorMsz('');
        }, 1000);
      }
      })
      .catch(error => {
        setFutureSLErrorMsz(`Error: ${error.message}`);
      setShowFutureSLApiError(true);
      setFutureSectionState((prevState) => {
        const newState = {
        ...prevState,
        futureSL: "",
        volume: '',
        futureRemark: 'Please Note That Stop Loss is Zero, Please Calculate Risk Before Initiating Trade.'
        };
        onFutureSectionChange(newState);
        return newState;
      });
      setLoading(false);
      setTimeout(() => {
        setShowFutureSLApiError(false);
        setFutureSLErrorMsz('');
      }, 1000);
      console.error('Error fetching data:', error);
      });


  }



  return (
    <div className="futuremain">

      {loading ?
        <div style={{
          position: "fixed",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          zIndex: 2,
        }}>
          <Loading />
        </div> : null}
      <div id="btnfutureDiv" className="btnfuturediv">
        <p>BUY</p>
        <input type="radio" value="BUY" defaultChecked name="futureReportType" onChange={handleChange} />

        <p>Sell</p>
        <input type="radio" value="Sell" name="futureReportType" onChange={handleChange} />
      </div>

      <div id="future_content" className="futurecontent">
        <div>
          <p>Chart-Image Interval:</p>
          <select value={futureSectionState.chartImageInterval} id="chartImageInterval" name="chartImageInterval" onChange={handleChartinterval}>
            <option value="4h">4h</option>
            <option value="1D">1D</option>
            <option value="1W">1W</option>
            <option value="1M">1M</option>
            <option value="1Y">1Y</option>
          </select>
        </div>

        <div>
          <p>Stock Name:<span className='asterisk'>*</span></p>


          <ReactSelect
            id="FutureStocktype"
            name="stockType"
            options={options}
            onChange={handlechangestock}
            styles={customStyles}
            disabled={!isEditable}
          />
        </div>

        {expiryshow ?
          <div style={{ marginTop: '16px' }}>
            <p>Expiry:<span className='asterisk'>*</span></p>
            <select id="Futureexpiry" name="Expiry" value={futureSectionState.Expiry} onChange={handlechangeExpiry} disabled={!isEditable}>
              <option value="">Select Expiry</option>
              {expiryData.map((expiry) => (
                <option key={expiry.instrument_token} value={expiry.expiry}>
                  {formatDate(expiry.expiry)}
                </option>
              ))}
            </select>
          </div>
          : null}
        {cmperror ? <span style={{ color: 'red', fontSize: '15px' }}>Numeric input with 2 decimal places (0-9).</span> : null}
        {showCmpApiError ? <span style={{ color: 'red', fontSize: '15px' }}>{CmpErrorMsz}</span> : null}

        <div style={{ marginTop: '16px' }} >

          <p>UnderLying Price:<span className='asterisk'>*</span></p>
          <button class="fetch" style={{ cursor: futureSectionState.stockType == '' ? 'not-allowed' : 'pointer' }} disabled={futureSectionState.stockType == ''} onClick={fetchCMP}>Fetch</button>
          <input value={futureSectionState.cashCMP} type="number" id="cashcmp" name="cashCMP" onChange={handleInputChange} disabled={!isEditable} />
        </div>



        {futurecmperror ? <span style={{ color: 'red', fontSize: '15px' }}>Numeric input with 2 decimal places (0-9).</span> : null}
        {showFutureCmpApiError ? <span style={{ color: 'red', fontSize: '15px' }}>{FutureCmpErrorMsz}</span> : null}
        <div>
          <p>Future CMP:<span className='asterisk'>*</span></p>
         
          <input value={futureSectionState.futureCMP} type="number" id="futurecmp" name="futureCMP" onChange={handleInputChange} disabled={!isEditable} />
        </div>



        {slerror ? <span style={{ color: 'red', fontSize: '15px' }}>Numeric input with 2 decimal places (0-9).</span> : null}
        {showFutureSLApiError ? <span style={{ color: 'red', fontSize: '15px' }}>{FutureSLErrorMsz}</span> : null}

        <div>
          <p>SL :<span className='asterisk'>*</span></p>
          <input value={futureSectionState.futureSL} type="number" pattern="^[0-9]*$" id="FutureSL" name="futureSL" onChange={handleInputChange} disabled={!isEditable} />
        </div>

        {volumeError ? <span style={{ color: 'red', fontSize: '15px' }}>Numeric input with 2 decimal places (0-9).</span> : null}

        <div>
          <p>Volume:</p>
          <input value={futureSectionState.volume} type="number" id="volume" name="volume" onChange={handleInputChange} disabled={!isEditable} />
        </div>

        <div>
          <p>Lot Size:</p>

          <input value={futureSectionState.lot_size} type="number" id="lot_size" name="lot_size" readOnly required />


        </div>
        {showFutureMarginApiError ? <span style={{ color: 'red', fontSize: '15px' }}>{FutureMarginErrorMsz}</span> : null}
        <div>
          <p>margin:</p>

          <input value={futureSectionState.margin} type="number" id="margin" name="margin" required onChange={handleChange} />


        </div>

        <div>
          <p>Select commentary:<span className='asterisk'>*</span></p>
          <select id="selectcommentry" name="commentry" value={commenteryData.find(item => item.Description === futureSectionState.commentry)?.CommentaryName || ''} onChange={handleOptionChange} disabled={!isEditable}>
            <option value="">Select commentary</option>
            {commenteryData.map((data) => (
              <option className='commentery-option' key={data.CommentaryName} value={data.CommentaryName}>
                {data.CommentaryName}
              </option>
            ))}
          </select>



        </div>



        <div>
          <p>Commentary Remarks:</p>
          <textarea style={{
            border: `2px solid ${futureSectionState.futureSL == '0' ? 'red' : 'rgba(0, 0, 0, 0.2)'}`,
            outline: 'none',
          }} value={futureSectionState.futureRemark} id="futureremark" name="futureRemark" rows={4} onChange={handleChange} disabled={!isEditable} />
        </div>


      </div>


       <Dialog
              open={showAlert}
              onClose={() => { setshowAlert(false) }}
              aria-labelledby="alert-dialog-title"
              aria-describedby="alert-dialog-description"
            >
              <p style={{ color: "green", padding: '10px 30px 10px 30px', margin: 0 }}>{AlertMessage}</p>
            </Dialog>
    </div>
  );
};

export default FutureSection;
